import { Theme } from '@mui/material/styles';

export const privateNoteButtonStyles = (theme: Theme) => ({
  '& .MuiButton-containedPrimary': {
    backgroundColor: theme.palette.custom.OV.custom.InternalNotes.noteButton,
    '&:hover': {
      backgroundColor: theme.palette.custom.OV.custom.InternalNotes.noteButtonHover,
    },
  },
  '& .MuiButton-textPrimary': {
    color: theme.palette.custom.OV.custom.InternalNotes.noteButton,
  },
});
